<template lang="">
  <van-popup
    v-model="visible"
    :closeable="false"
    position="bottom"
    close-on-popstate
    safe-area-inset-bottom
    :style="{ height: '50%', width: '100%' }"
    @closed="onClose"
  >
    <van-tabs v-model="activeKey" line-width="40%">
      <van-tab name="1" title="二维码授权">
        <form-select
          v-model="authPersonId"
          label="授权人"
          required
          :columns="authPersons"
          @change="handleChange"
          textField="UserName"
        ></form-select>

        <div class="qr-box">
          <template v-if="imgurl">
            <span v-if="isExpire" @click="reflesh" class="layer">
              <van-icon name="replay" class="icon" />
              <p>
                二维码失效 点击重试
              </p>
            </span>
            <img :src="imgurl" alt="扫码授权" />
            <small>请让授权人使用微信扫码授权</small>
          </template>
        </div>
      </van-tab>
      <van-tab name="2" title="管理员密码授权" force-render>
        <div class="pass-area">
          <van-field
            v-model="authPassWord"
            center
            clearable
            required
            label="授权密码"
            placeholder="请输入授权密码"
            size="large"
            autocomplete="off"
            type="password"
          >
          </van-field>
          <van-button
            type="primary"
            @click="onSubmit"
            block
            style="margin-top:10px"
            >确定</van-button
          >
        </div>
      </van-tab>
    </van-tabs>
  </van-popup>
</template>

<script>
import { Button, Popup, Tab, Tabs, Field, Icon, Toast } from "vant";
import md5 from "js-md5";
import loginAdminApi from "@/api/loginAdmin";
import formSelect from "@/components/form-select/formSelect";
import { getUid } from "@/utils/common";
export default {
  components: {
    formSelect,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  props: {
    token: {
      type: String,
      default: "",
    },
    companyCode: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "登录授权",
    },
    submit: Function,
    cancel: Function,
    loginParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      imgurl: "",
      isExpire: false,
      authPersons: [],
      activeKey: "1",
      authPersonId: "",
      spinning: false,
      authPerson: {},
      authPassWord: "",
      isSuccess: false,
      adminPassword: "",
    };
  },
  mounted() {
    this.getAuthPersons();
  },
  methods: {
    getAuthPersons() {
      loginAdminApi.GetLoginAdmin({ notToken: false }).then(res => {
        let data = res.Data;
        if (data.Password) {
          this.adminPassword = data.Password;
          this.authPersons = res.Data.LoginAdmins.filter(el => {
            el.id = getUid();
            if (el.OpenId) {
              return true;
            }
            return false;
          });
          this.visible = true;
        } else {
          this.onSubmitAfter();
        }
      });
    },
    handleChange(sel) {
      this.authPerson = sel;
      if (this.authPerson.OpenId) {
        this.getQrCode(this.authPerson.OpenId);
      }
    },
    reflesh() {
      this.isExpire = false;
      this.getQrCode(this.authPerson.OpenId);
    },
    getQrCode(openId) {
      let that = this;
      if (!that.isExpire) {
        that.spinning = true;
        loginAdminApi
          .getQRCode({
            openId,
            companyCode: this.companyCode,
            notToken: true,
          })
          .then(response => {
            that.imgurl = "data:image/jpeg;base64," + response.Data.QRCode;
            that.spinning = false;
            loginAdminApi
              .LongPolingLogin(
                {
                  id: response.Data.KeyId,
                  notToken: true,
                },
                {
                  timeout: 3 * 60000,
                  headers: {
                    handleError: false,
                    isLoading: false,
                  },
                },
              )
              .then(() => {
                this.$emit("submit");
                this.isSuccess = true;
                this.visible = false;
              })
              .catch(() => {
                that.isExpire = true;
                that.spinning = false;
              });
          })
          .catch(() => {
            that.isExpire = true;
            that.spinning = false;
          });
      }
    },
    onSubmit() {
      const { authPassWord } = this;
      if (!authPassWord) {
        Toast("请输入授权密码");
        return false;
      }
      let values = {};
      values.authPassWord = md5(authPassWord, 32);
      if (this.adminPassword == values.authPassWord) {
        this.onSubmitAfter();
      } else {
        Toast("密码错误");
      }
    },
    onSubmitAfter() {
      this.onAddAudit();
      this.$emit("submit");
      this.isSuccess = true;
      this.visible = false;
    },
    /**
     * @description: 授权记录
     * @param {*} type
     * @return {*}
     */
    onAddAudit() {
      loginAdminApi.AddLoginAdminLog(
        {
          urlQuery: `?CompanyCode=${this.companyCode}`,
        },
        {
          headers: {
            Authorization: this.token,
          },
        },
      );
    },
    onClose() {
      if (!this.isSuccess) {
        this.$emit("cancel");
      }
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin: 5px 0;
  label {
    min-width: 100px;
    text-align: right;
    small {
      color: #f00;
    }
  }
}
.qr-box {
  text-align: center;
  padding: 15px 0;
  position: relative;
  height: 240px;
  img {
    width: 170px;
  }
  span {
    display: block;
    margin: 10px;
  }
  small {
    display: block;
    margin: 10px;
    color: #1890ff;
  }
  .anticon-reload {
    font-size: 40px;
    display: block;
    margin: 30px;
  }
  .layer {
    position: absolute;
    left: 50%;
    top: 15px;
    width: 170px;
    height: 170px;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 14px;
    transform: translateX(-50%);
    margin: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .icon {
      font-size: 30px;
      margin-bottom: 20px;
    }
  }
}
.pass-area {
  padding: 10px;
}
</style>
